import axios from 'axios';
import constants from '../../config/constants';
import {
  setGlobalCurrentBatchUtils,
  setGlobalActualCurrentBatchUtils,
  getGlobalSchoolUtils,
} from '../../utils/commonFunc';

export const GET_ALL_BATCHES = 'GET_ALL_BATCHES';
export const GET_BATCH = 'GET_BATCH';
export const GET_SCHOOL_BATCHES = 'GET_SCHOOL_BATCHES';
export const GET_CURRENT_BATCH = 'GET_CURRENT_BATCH';

//= ========== Reducer call functions begin ===========//
export const getAllBatches = batchData => ({
  type: GET_ALL_BATCHES,
  batchData,
});

export const getSchoolBatches = batches => ({
  type: GET_SCHOOL_BATCHES,
  batches,
});

export const getBatch = batch => ({
  type: GET_BATCH,
  batch,
});

export const getCurrentBatch = batchData => ({
  type: GET_CURRENT_BATCH,
  batchData,
});
//= ========== Reducer call functions begin ===========//

// Cancel Request
export const batchAPIController = new AbortController();
//= ========== User routing begin ===========//
export const fetchAllBatchsService = data => async dispatch => {
  try {
    const res = await axios.get(
      `${constants.API_BASE_URL}/api/admin/get-school-batch-by-page/${data.schoolId}${constants.makeParams(
        data.pageParams
      )}`,
      constants.setHeader(data.token, null, null, batchAPIController)
    );
    dispatch(getAllBatches(res.data));
    return res.data;
  } catch (err) {
    console.error('Err-fetchAllBatchsService', err.response);
  }
};

export const fetchSchoolBatchedHandler = async data => {
  const { schoolId = data?.schoolId } = getGlobalSchoolUtils() || {};
  try {
    const res = await axios.get(
      `${constants.API_BASE_URL}/api/admin/get-school-batch/${schoolId}`,
      constants.setHeader(data?.token, null, null, batchAPIController)
    );
    return res;
  } catch (err) {
    console.error('Err-fetchSchoolBatchedHandler', err.response);
    return err;
  }
};

export const fetchSchoolBatchsService = data => async dispatch => {
  try {
    const res = await fetchSchoolBatchedHandler(data);
    dispatch(getSchoolBatches(res.data));
    return res.data;
  } catch (err) {
    console.error('Err-fetchSchoolBatchedHandler', err.response);
  }
};

export const saveBatchService = data => async () => {
  return axios.post(`${constants.API_BASE_URL}/api/admin/create-batch`, data.postData, constants.setHeader(data.token));
};

export const fetchBatchService = data => async dispatch => {
  try {
    const res = await axios.get(
      `${constants.API_BASE_URL}/api/admin/get-batch/${data.batchId}`,
      constants.setHeader(data.token, null, null, batchAPIController)
    );
    dispatch(getBatch(res.data));
    return res.data;
  } catch (err) {
    console.error('Err-fetchBatchService', err);
  }
};

export const updateBatchService = data => () => {
  return axios.put(
    `${constants.API_BASE_URL}/api/admin/update-batch/${data.batchId}`,
    data.postData,
    constants.setHeader(data.token, null, null, batchAPIController)
  );
};

export const deleteBatchService = data => () => {
  return axios.delete(
    `${constants.API_BASE_URL}/api/admin/delete-batch/${data.batchId}`,
    constants.setHeader(data.token, null, null, batchAPIController)
  );
};

export const fetchCurrentBatchByCourseService = data => async dispatch => {
  const res = await axios.get(
    `${constants.API_BASE_URL}/api/admin/current-batch-by-course/${data.courseId}`,
    constants.setHeader(data.token, null, null, batchAPIController)
  );
  dispatch(getCurrentBatch(res.data));
};

export const fetchCurrentBatchByYearService = data => async dispatch => {
  try {
    const res = await axios.get(
      `${constants.API_BASE_URL}/api/admin/current-batch-by-year/${data.schoolId}/${data.startYear}/${data.endYear}`,
      constants.setHeader(data.token, null, null, batchAPIController)
    );
    // if (res.data) {
    const bData = {
      batchId: res.data.batchId,
      startYear: res.data.startYear,
      endYear: res.data.endYear,
    };
    setGlobalCurrentBatchUtils(bData);
    setGlobalActualCurrentBatchUtils(bData);
    dispatch(getCurrentBatch(res.data));
  } catch (err) {
    console.error('Err-fetchCurrentBatchByYearService', err?.response);
  }
};

export const fetchSchoolBatchesApi = async data => {
  const { schoolId = data?.schoolId } = getGlobalSchoolUtils() || {};
  try {
    const res = await axios.get(
      `${constants.API_BASE_URL}/api/admin/get-school-batch/${schoolId}`,
      constants.setHeader(data.token)
    );
    return res?.data;
  } catch (err) {
    console.error('fetchSchoolBatchesApi', err);
  }
};

// Clone batch section
export const GET_ALL_CLONED_BATCHES = 'GET_ALL_CLONED_BATCHES';
export const getAllClonedBatches = cloneBatchList => ({
  type: GET_ALL_CLONED_BATCHES,
  cloneBatchList,
});
export const fetchAllClonedBatchesApi = async data => {
  const { token, schoolId, dispatch } = data;
  try {
    const res = await axios.get(
      `${constants.API_BASE_URL}/api/all-academic-year/${schoolId}`,
      constants.setHeader(token)
    );
    dispatch(getAllClonedBatches(res?.data));
    return res?.data;
  } catch (err) {
    console.error('fetchAllClonedBatchesApi', err);
  }
};

export const intiateBatchCloneApi = async data => {
  return axios.post(
    `${constants.API_BASE_URL}/api/request-academic-year/${data?.schoolId}`,
    data.postData,
    constants.setHeader(data.token)
  );
};
//= ========== User routing end ===========//
